import React from 'react'
import { CaseData } from './Cases'
import styles from './Cases.module.scss'

interface CaseItemModalContentProps {
  data: CaseData
}

export const CaseItemModalContent: React.FC<CaseItemModalContentProps> = ({ data }) => {
  const { title, industry, fullData } = data

  return (
    <div className={styles.modalContent}>
      <div className={styles.modalHeader}>
        <div>
          <h3 className={styles.modalTitle}>{title}</h3>
          <p className={styles.modalIndustry}>{industry}</p>
        </div>
      </div>

      <p className={styles.tablePeriodHint}>Показатели в месяц</p>

      <div className={styles.tableWrapper}>
        <table className={styles.comparisonTable}>
          <thead>
            <tr>
              <th>Показатель</th>
              <th>Было</th>
              <th>Стало</th>
            </tr>
          </thead>
          <tbody>
            {fullData.metrics.map((metric, idx) => (
              <tr key={idx}>
                <td>{metric.name}</td>
                <td>{metric.before}</td>
                <td className={styles.afterValue}>{metric.after}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className={styles.driversBlock}>
        <h4 className={styles.driversTitle}>📌 Ключевые драйверы роста:</h4>
        <ul className={styles.driversList}>
          {fullData.drivers.map((driver, idx) => (
            <li key={idx}>{driver}</li>
          ))}
        </ul>
      </div>
    </div>
  )
}
